import axios from "../network/reuset";
import qs from "qs";

const getChannel = {
  getChannelList(params) {
    return axios.post(`/api/admin/channel/list`, qs.stringify(params));
  },
  copyChannel(params) {
    return axios.post(`/api/admin/channel/copy`, qs.stringify(params));
  },
  copyChannelConfig(params) {
    return axios.post(`/api/admin/channel/copy_config`, qs.stringify(params));
  },
  addChannel(params) {
    return axios.post(`/api/admin/channel/add`, qs.stringify(params));
  },
  deleteChannel(params) {
    return axios.post(`/api/admin/channel/del`, qs.stringify(params));
  },
  getChannelInfo(params) {
    return axios.post(`/api/admin/channel/info`, qs.stringify(params));
  },
  saveChannel(params) {
    return axios.post(`/api/admin/channel/save`, qs.stringify(params));
  },
  saveChannelConfig(params) {
    return axios.post(`/api/admin/channel/config/save`, qs.stringify(params));
  },
  getChannelTemplateOptions(params) {
    return axios.post(`/api/admin/channel/template_options`, qs.stringify(params));
  },
  addChannelRule(params) {
    return axios.post(`/api/admin/channel_rule/add`, qs.stringify(params));
  },
  getChannelRuleList(params) {
    return axios.post(`/api/admin/channel_rule/list`, qs.stringify(params));
  },
  saveChannelRule(params) {
    return axios.post(`/api/admin/channel_rule/save`, qs.stringify(params));
  },
  getChannelRuleInfo(params) {
    return axios.post(`/api/admin/channel_rule/info`, qs.stringify(params));
  },
  deleteChannelRule(params) {
    return axios.post(`/api/admin/channel_rule/del`, qs.stringify(params));
  },
  getChannelUserList(params) {
    return axios.post(`/api/admin/channel_user/list`, qs.stringify(params));
  },
  getUserTriggerRuleList(params) {
    return axios.post(`/api/admin/channel_trigger_rule/list`, qs.stringify(params));
  },
  getChannelRiskPolicyList(params) {
    return axios.post(`/api/admin/channel_risk_policy/list`, qs.stringify(params));
  },
  getChannelRiskPolicyInfo(params) {
    return axios.post(`/api/admin/channel_risk_policy/info`, qs.stringify(params));
  },
  getChannelRiskPolicyOptions(params) {
    return axios.post(`/api/admin/channel_risk_policy/options`, qs.stringify(params));
  },
  addChannelRiskPolicy(params) {
    return axios.post(`/api/admin/channel_risk_policy/add`, qs.stringify(params));
  },
  saveChannelRiskPolicy(params) {
    return axios.post(`/api/admin/channel_risk_policy/save`, qs.stringify(params));
  },
  deleteChannelRiskPolicy(params) {
    return axios.post(`/api/admin/channel_risk_policy/del`, qs.stringify(params));
  },
  postAddChannel(params) {
    return this.addChannel(params);
  },
  postDelChannel(params) {
    return this.deleteChannel(params);
  },
  getChannelDetail(params) {
    return this.getChannelInfo(params);
  },
  postSaveChannelInfo(params) {
    return this.saveChannel(params);
  },
  postAddChannelRule(params) {
    return this.addChannelRule(params);
  },
  postSaveChannelRule(params) {
    return this.saveChannelRule(params);
  },
  getInfoChannelRule(params) {
    return this.getChannelRuleInfo(params);
  },
  delChannelRule(params) {
    return this.deleteChannelRule(params);
  },
  delChannelRiskPolicy(params) {
    return this.deleteChannelRiskPolicy(params);
  },
};

export default getChannel;
